
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class PDCPayableDialog extends _Ext.DialogBase<PDCPayableRow, any> {
        protected getFormKey() { return PDCPayableForm.formKey; }
        protected getIdProperty() { return PDCPayableRow.idProperty; }
        protected getLocalTextPrefix() { return PDCPayableRow.localTextPrefix; }
        protected getNameProperty() { return PDCPayableRow.nameProperty; }
        protected getService() { return PDCPayableService.baseUrl; }
        protected getDeletePermission() { return PDCPayableRow.deletePermission; }
        protected getInsertPermission() { return PDCPayableRow.insertPermission; }
        protected getUpdatePermission() { return PDCPayableRow.updatePermission; }

        protected form = new PDCPayableForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        constructor() {
            super();
            q.setTextRightAlign(this.form.Amount);
            q.setTextRightAlign(this.form.ChequeNo);
        }

    }
}